module.exports = __webpack_public_path__ + "static/media/mdm1.9e572b3f.png";